// extracted by mini-css-extract-plugin
export default {"buttons":"InProgressPreregisterModal_buttons__aEpfL","text":"InProgressPreregisterModal_text__U5jL7"};